import VixtingAdmissionLogs from './VixtingAdmissionLogs';

export default VixtingAdmissionLogs;
